import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
  Col,
  Container,
  Row,
} from 'reactstrap';
import get from 'lodash/get';

import { parseUrlParams } from 'utils/parseUrlParams';

const CreditFreeze = (props) => {
  useEffect(() => {
    window.scrollTo(0, 0);
    const params = parseUrlParams(window.location.search);

    if (!params.key) {
      props.history.push(`/applications/${props.match.params.workflowtype}/application`);
    } else if (!get(props.workflow, 'data.data', get(props.workflow, 'state.data'))) {
      props.history.push(`/applications/${props.match.params.workflowtype}/checkin?key=${params.key}`);
    }
  }, []);

  return (
    <div className="page-preapproved narrow">
      <Container>
        <Row>
          <Col lg={{ size: 10, offset: 1 }} className="text-center mb-2 mt-2 mt-md-4">
            <p className="mb-0">
              <b>Application ID:</b>
              {' '}
              {get(props.workflow, 'attributes.entityId')}
            </p>
            <img src="/icons/declined.svg" alt="Declined" className="mb-3" />
            <h2 className="mb-0">Your Credit Is Frozen</h2>
            <p className="mb-4">Thank you for your application.</p>
            <p className="mb-0">The following actions are needed so that a decision can be made on your application:</p>

            <Row>
              <Col>
                <h4 className="mb-1 text-primary">Please contact TransUnion to remove the freeze from your credit report.</h4>
                <h4 className="mb-4 text-primary">After the removal of the credit freeze, please call us back at (877) 203-4747</h4>
                <hr />
                <p className="p-large">You must complete the above actions within 30 days. If you do not complete the above actions within 30 days we will regrettably be unable to give further consideration to your credit request.</p>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

CreditFreeze.propTypes = {
  history: PropTypes.object.isRequired,
  workflow: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
};

CreditFreeze.defaultProps = {
};

export default compose(
  withRouter,
  connect(
    (state) => ({
      workflow: state.workflow,
    })
  )
)(CreditFreeze);
